import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import keys from 'lodash/keys';
import isEqual from 'lodash/isEqual';

export function differencesInObject<T extends object>(obj1: T, obj2: T): Record<keyof T, boolean> {
  const differences: Record<keyof T, boolean> = {} as Record<keyof T, boolean>;

  if (!isObject(obj1) || !isObject(obj2)) {
    return differences;
  }

  for (const key of keys(obj1)) {
    const keyName = key as keyof T;

    if (isArray(obj1[keyName])) {
      differences[keyName] = isEqual(obj1[keyName], obj2[keyName]);
    } else if (isObject(obj1[keyName])) {
      differences[keyName] = isEqual(obj1[keyName], obj2[keyName]);
    } else {
      differences[keyName] = obj1[keyName] === obj2[keyName];
    }
  }

  return differences;
}
